import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "validateCutoff"
})
export class ValidateCutoffPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}
